<template>
	<div id="app">
		<div class="header-fixed">
			<div class="header flex">
				<div class="logo_img" @click="logoClick">
					<div style="display:flex; align-items: center; float:left; height: 65px;">
						<div class="header-logo">
							<img id="header-img" src="../assets/logo.png">
						</div>
					</div>
				</div>
				<div id="menu_index">
					<ul class="nav">
						<li class="header-title" :class="navIndex == index ? 'active' : ''" v-for="(item, index) in navItems" :key="index" @click="handleNavClick(item, index)">
							{{ item.name }}
							<div class="n_subclass">
								<a v-for="(subItem, subIndex) in item.subItems" :key="subIndex"
									:href="`#${subItem.id}`">
									{{ subItem.name }}
								</a>
							</div>
						</li>
					</ul>
				</div>
				<!-- 电话联系 -->
				<div class="phone_icon flex">
					<img id="phone_img" src="../../static/home/phone_icon.png">
					<span>156-5668-8828</span>
				</div>
			</div>
		</div>
		<div class="container" style="clear: both;">
			<router-view></router-view>
		</div>
		<!-- 底部 -->
		<div class="footer">
			<div class="footer-con">
				<div class="footer-con-t">
					<img id="footer-img" src="../../static/home/bottom-logo.png">
					<ul class="f_nav">
						<li @click="handleNavClick1('/walkInto')">
							<a class="f_a0"><b>关于我们</b></a>
							<a href="/#profile">公司介绍</a>
							<a @click.stop="handleNavClick1('/hire')">人才招聘</a>
							<a href="/#development">发展历程</a>
							<a href="/#store">金信泰门店</a>
						</li>
						<li @click="handleNavClick1('/pawnProducts')">
							<a href="/product/" class="f_a0"><b>典当产品</b></a>
							<a href="/#house">我有房产</a>
							<a href="/#car">我有汽车</a>
							<a href="/#gold">我有奢品</a>
							<a href="/#gold">我有数码</a>
						</li>
					</ul>
					<div class="f_tel">
						<p class="f18 tel_tit">联系电话：156-5668-8828</p>
						<p class="address">
						<p class="mb-10">营业执照注册地址：</p>
						<p class="mb-10">深圳市福田区金田路3038号现代国际2008</p>
						</p>
					</div>
					<div class="wx-pic">
						<div class="tel_tit">客服微信</div>
						<img src="../../static/home/erweima.png" style="height: 100px;width: 100px" alt="" />
					</div>
				</div>
				<div class="record">
					<a class="record" href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff">Copyright © 2025.皖ICP备2022006755号 金信泰典当</a >
				</div>
			</div>
		</div>
		<!-- 回到顶部 -->
		<div id="back_to_top" class="back_to_top" ref="btn" style="display: none;">
			<div class="back-up">
				<div class="back-up-item back-up-item1">
					<img class="code-img" src="../../static/home/qr-code.png" style="height: 33px;width: 33px" />
					<div class="back-l">
						<img class="QR-code" src="../../static/home/erweima.png" style="height: 100px;width: 100px"
							alt="" />
						<p class="p-t">客服微信</p>
					</div>
				</div>
				<div @click="backTop" class="back-up-item">
					<img class="code-img" src="../../static/home/up.png" style="height: 30px;width: 26px" />
				</div>
			</div>
		</div>
		<!-- 底部 -->
		<div ref="btn1" class="loan-application" style="display: none;">
			<div class="loan">
				<div class="loan-l">
					<p>借款咨询</p>
					<p class="tel-icon"><img src="../../static/home/tel-icon.png" alt="" />156-5668-8828</p>
				</div>
				<div class="loan-c">
					<img src="../../static/home/popup-phone.png" alt="" />
					<input v-model="userPhone" class="loan-ipt" type="number" placeholder="请输入手机号" />
					<span class="btn" @click="submit">借款申请</span>
				</div>
				<div class="loan-r">
					<div>扫一扫<br />咨询更多</div>
					<img class="wx-code" src="../../static/home/erweima.png" alt="" />
				</div>
				<img @click="closeFun()" class="close-img" src="../../static/home/close.png" alt="" />
			</div>
		</div>
		<Dialog :centerDialogVisible="centerDialogVisible" @close="close"></Dialog>
	</div>
</template>

<script>
	import Dialog from './Dialog.vue'
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	export default {
		name: "Layout",
		components: {
			Dialog
		},
		data() {
			return {
				navIndex: 0,
				centerDialogVisible: false,
				activeIndex: '1',
				company: {
					qrcode: require("../../static/other/yundangpu.png"),
				},
				scroll: '',
				timer: '',
				seen: true,
				currentMenu: '首页',
				userPhone: '',
				navItems: [{
						name: '首页',
						subItems: [],
						to: '/'
					},
					{
						name: '走进金信泰',
						to: '/walkInto',
						subItems: [{
								name: '公司简介',
								id: 'profile'
							},
							{
								name: '公司荣誉',
								id: 'honor'
							},
							{
								name: '发展历程',
								id: 'development'
							},
							{
								name: '人才招聘',
								id: 'recruitment'
							},
							{
								name: '金信泰门店',
								id: 'store'
							}
						],
					},
					{
						name: '我要典当',
						to: '/myPawn',
						subItems: [{
								name: '申请借款',
								id: 'profile'
							},
						],
					},
					{
						name: '典当产品',
						to: '/pawnProducts',
						subItems: [{
								name: '我有汽车',
								id: 'car'
							},
							{
								name: '我有房产',
								id: 'house'
							},
							{
								name: '黄金典当',
								id: 'gold'
							},
							{
								name: '奢品典当',
								id: 'gold'
							},
							{
								name: '数码典当',
								id: 'gold'
							},
						],
					},
					{
						name: '典当问答',
						to: '/answer',
						subItems: [{
								name: '典当须知',
								id: 'answer'
							},
							// {
							// 	name: '金信泰课堂',
							// 	id: 'answer'
							// },
						],
					},
					{
						name: '渠道合作',
						to: '/channel',
						subItems: [],
					},
					{
						name: '今日金价',
						to: '/gold',
						subItems: [],
					},
				]
			};
		},
		mounted() {
			this.menuSeen()
			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleNavClick1(path) {
				this.$router.push({
					path: path
				});
			},
			handleNavClick(item, index) {
				this.navIndex = index
				// 没有子栏目，直接跳转
				this.$router.push({
					path: item.to
				});
				// this.backTop()
			},
			close(flag) {
				this.centerDialogVisible = flag
			},
			submit() {
				if (this.userPhone == '') {
					this.$message.error('请输入手机号');
					return false
				}

				let res = this.util.request({
					url: `/sy/getLfWebsite/submitFrom`,
					method: 'POST',
					data: {
						isCode: 0,
						userPhone: this.userPhone,
						clueType: 0,
					},
				}).then(res => {
					if (res.status === 200) {
						this.centerDialogVisible = true
						this.userPhone = ''
					}
				}).catch(error => {
					this.$message.error(error);
				});
			},
			getOpenMinChengXuLink() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const CheckCsrf = encryptLong(sySign + timeStamp);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					console.log('pc端不跳转')
					return;
				}

			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			},
			subHandleSelect(path, id) {
				this.$router.push({
					path,
					query: {
						id: id
					}
				}, onComplete => {}, onAbort => {})
			},
			handleSelect(key) {
				console.log(key)
				switch (key) {
					case '1':
						this.$router.push({
							name: "Index"
						});
						break;
					case '2':
						this.$router.push({
							path: '/walkInto',
							// query: {
							// 	id: value
							// }
						}, onComplete => {}, onAbort => {})
						window.location.hash = "#走进金信泰";
						break;
					case '3':
						this.$router.push({
							path: '/myPawn',
						}, onComplete => {}, onAbort => {})
						window.location.hash = "#我要典当";
						break;
					case '4':
						this.$router.push({
							path: '/pawnProducts',
						}, onComplete => {}, onAbort => {})
						window.location.hash = "#典当产品";
						break;
					case '5':
						this.$router.push({
							name: "answer"
						});
						window.location.hash = "#典当问答";
						break;
					case '6':
						this.$router.push({
							name: "channel"
						});
						window.location.hash = "#渠道合作";
						break;
					case '7':
						this.$router.push({
							name: "gold"
						});
						window.location.hash = "#今日金价";
						break;
				}
			},
			handleSelectMobile(key) {
				switch (key) {
					case '1':
						this.$router.push({
							name: "Index"
						});
						this.currentMenu = '首页';
						break;
					case '3':
						this.$router.push({
							name: "Index"
						});
						window.location.hash = "#寄存回收";
						this.currentMenu = '首页';
						break;
					case '4':
						this.$router.push({
							name: "Index"
						});
						window.location.hash = "#延期买回";
						this.currentMenu = '首页';
						break;
					case '5':
						this.$router.push({
							name: "Index"
						});
						window.location.hash = "#关于我们";
						this.currentMenu = '首页';
						break;
				}
			},
			handleScroll() {
				this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
				let btn = document.querySelector('.back_to_top')
				let btn1 = document.querySelector('.loan-application')
				if (this.scroll > 600) { //判断滚动后高度超过400px,就显示
					btn.style.display = 'block'
					btn1.style.display = 'block'
				} else {
					btn.style.display = 'none'
					btn1.style.display = 'none'
				}
			},
			backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
				this.timer = setInterval(() => {
					let osTop = document.documentElement.scrollTop || document.body.scrollTop;
					let ispeed = Math.floor(-osTop / 5)
					document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
					if (osTop === 0) {
						clearInterval(this.timer)
					}
				}, 30)
			},
			closeFun() {
				this.$refs.btn1.style.display = 'none'
			},
			menuSeen() {
				// 屏幕尺寸
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 415) {
					this.seen = true;
				} else {
					this.seen = false;
				}
			},
			logoClick() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const CheckCsrf = encryptLong(sySign + timeStamp);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					location.reload();
				}

			}
		},
		
	}
</script>

<style scoped>
	.flex {
		display: flex;
		align-items: center;
	}

	.flex-1 {
		flex: 1;
	}

	.container {
		margin-top: 65px;
		background-color: #f5f5f5;
	}

	.el-menu-item.is-active {
		border: none;
	}

	.xiaochengxu {
		position: absolute;
		margin-right: 10%;
	}

	.header-fixed {
		justify-content: flex-end;
		display: flex;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		background-color: #fff;
		z-index: 999;
	}

	.logo_img {
		float: left;
		width: 23%;
		cursor: pointer;
	}

	#back_to_top {
		position: fixed;
		bottom: 200px;
		right: 30px;
		cursor: pointer;
	}

	.back-l {
		width: 124px;
		height: 157px;
		background: #FFFFFF;
		box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		margin-right: 10px;
		text-align: center;
		position: absolute;
		top: 0;
		right: 100%;
		display: none;
	}

	.back-l .p-t {
		font-weight: 600;
		font-size: 14px;
		color: #333333;
	}

	.back-l .QR-code {
		margin-top: 13px;
	}

	.back-up-item {
		width: 50px;
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.1);
		border-radius: 7px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 2px;
	}

	.back-up-item1 {
		position: relative;
	}

	.back-up-item1:hover .back-l {
		display: block;
	}

	.header-title {
		height: 65px;
		line-height: 65px;
		font-size: 15px;
		position: relative;
		cursor: pointer;
	}

	.header-title a {
		display: inline-block;
		width: 110px;
		height: 65px;
		line-height: 65px;
	}

	.header-title:hover .n_subclass {
		display: block;
		font-weight: 400 !important;
	}

	.n_subclass a:hover {
		background-color: rgba(255, 255, 255, .2);
	}

	.n_subclass a:last-child:hover {
		border-radius: 0px 0px 8px 8px;
	}

	.n_subclass {
		position: absolute;
		top: 65px;
		left: 50%;
		transform: translateX(-50%);
		background: #DF9C03;
		border-radius: 0px 0px 8px 8px;
		font-size: 14px;
		color: #FFFFFF;
		display: none;
		transition: opacity 0.5s;
	}

	.n_subclass a {
		padding: 2px 5px;
		display: block;
		text-align: center;
		color: #fff;
		height: 40px;
		line-height: 40px;
	}

	.n_subclass a em {
		display: inline-block;
		padding: 0 8px;
		font-style: normal;
		border-bottom: 1px solid #DC6062;
	}

	.n_subclass a em:last-child {
		/* border: none; */
	}

	.header-title:hover {
		color: #DF9C03;
	}

	.company_name {
		font-weight: normal;
		font-size: 15px;
	}

	.footer_font {
		font-size: 15px;
	}

	#menu_index {
		float: left;
		height: 100%
	}

	.header {
		width: 1200px;
		margin: 0 auto;
		height: 65px;
	}

	.phone_icon {
		font-weight: 600;
		font-size: 15px;
		color: #DF9C03;
	}

	#phone_img {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}

	.nav {
		height: 65px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0;
		padding: 0;
	}

	.header-title {
		width: 110px;
		text-align: center;
		/* height: 60px;
		line-height: 60px; */
		font-size: 15px;
		position: relative;
		/* padding: 0 20px; */
	}

	@media screen and (max-device-width: 415px) {
		.logo_img {
			float: left;
			width: auto;
			cursor: pointer;
		}

		#back_to_top {
			position: fixed;
			bottom: 50px;
			right: 5px;
			cursor: pointer
		}

		.footer_font {
			font-size: 0.875rem;
		}

		#menu_index {
			float: right;
			width: auto;
			height: 100%
		}

		.mobile_menu {}
	}

	#header-img {
		/* width: 50px; */
		height: 50px;
		float: left;
		margin: auto;
	}

	.header-logo {
		height: 50px;
		width: 50px;
		align-self: center;
	}

	.header-important {
		float: left;
		margin-left: 6px;
		align-self: center;
	}

	a {
		text-decoration: none;
	}

	a:visited {
		text-decoration: none;
	}

	a:hover {
		text-decoration: none;
	}

	a:active {
		text-decoration: none;
	}

	/* 底部样式 */
	.footer {
		background: #333;
	}

	.footer-con {
		width: 1200px;
		margin: 0 auto;
	}

	.footer-con-t {
		position: relative;
		display: flex;
		padding: 70px 0;
		border-bottom: 1px solid #686868;
	}

	.record {
		padding: 50px 0;
		font-size: 14px;
		color: #999999;
	}

	#footer-img {
		width: 179px;
		height: 50px;
		;
	}

	.f_nav {
		margin: 0;
		display: flex;
	}

	.f_nav li {
		list-style: none;
		text-decoration: none;
		width: 200px;
	}

	.f_nav li .f_a0 {
		display: block;
		margin-bottom: 20px;
		font-weight: normal;
		font-size: 20px;
		color: #FFFFFF;
	}

	.f_nav li a {
		font-weight: normal;
		font-size: 14px;
		color: #999999;
		display: inline-block;
		padding: 0 10px;
		margin-bottom: 10px;
	}

	.f_tel {
		margin-right: 50px;
	}

	.f_tel p {
		font-weight: normal;
		font-size: 14px;
		color: #999999;
	}

	.f_tel .tel_tit {
		margin: 0;
		font-weight: normal;
		font-size: 20px;
		color: #FFFFFF;
		margin-bottom: 20px;
	}

	.address {
		font-weight: normal;
		font-size: 14px;
		color: #999999;
	}

	.mb-10 {
		margin: 0;
		margin-bottom: 10px;
	}

	.wx-pic {
		position: absolute;
		right: 0;
	}

	.wx-pic .tel_tit {
		font-weight: 600;
		font-size: 20px;
		color: #FFFFFF;
		text-align: center;
	}

	.wx-pic .img {
		width: 100px;
		height: 99px;
		background-color: pink;
		margin-top: 10px;
	}
	.wx-code {
		width: 80px;
		height: 79px;
		margin-left: 10px;
	}
	.close-img {
		width: 12px;
		height: 12px;
	}
	.active {
		color: #DF9C03;
		font-weight: 600;
	}
</style>


// WEBPACK FOOTER //
// src/components/Layout.vue